import React from "react";
import './Donation.css';

import { Link } from "react-router-dom";

import { AiTwotoneCalendar } from 'react-icons/ai';



const Donation = ({ donation }) => {

    // Destructure raised and goal amounts from donation object
    const raised = donation.donation.raised;
    const goal = donation.donation.goal;

    // Calculate donation progress percentage
    const percentage = (raised / goal) * 100;
    const displayPercentage = Math.round(percentage); // rounds to nearest whole number

    return (

        <div className="donation-item">

            <div className="image">
                <img src={donation.image} alt={donation.title} /> {/* Donation Image */}
            </div>

            <div className="content">

                {/* Link to the individual Donation page */}
                <Link
                    to={{
                        pathname: '/Donations/' + donation.title,  // Navigate to the specific Donation page
                    }}
                    location = {{donation}}  // Passing Donation details to the linked page
                    state= {donation}>
                    <h3>{donation.title}</h3> {/* Donation Title */}
                </Link>

                <div className='date'><AiTwotoneCalendar className='icon' /><span>{donation.date}</span></div>

                <p>{donation.content}</p> {/* Short donation description */}

                {/* Progress bar section */}
                <div className="skill-bar">
                    <span className="skill-progress" style={{ width: `${displayPercentage}%` }}>
                        <span className="skill-no">{displayPercentage}%</span> {/* Display donation percentage */}
                    </span>
                </div>

                {/* Display raised and goal amounts */}
                <div className='amount'>
                    <p><span>${donation.donation.raised}</span> Raised</p>
                    <p><span>${donation.donation.goal}</span> Goal</p>
                </div>

            </div>

        </div>
    );
};

export default Donation;